import angular from 'angular';
import './pp/app';
const singleAppTemplate = require('./mgmt/applications/singleapp-pmkp.tpl.html');
angular.module('tkr.custom')
    .decorator('customizationConfig', CustomizationConfigDecorator);
CustomizationConfigDecorator.$inject = ['$delegate'];
function CustomizationConfigDecorator($delegate) {
    const cc = $delegate;
    cc.prcListDetailTemplate = require('./mgmt/prc/prc-list.tpl.html');
    cc.getSingleAppTemplate = (appPeriod) => {
        return appPeriod.variant === 'pieksamaki' ? singleAppTemplate : undefined;
    };
    return cc;
}
